export const APP_VERSION = 'unknown';
export const APP_COMMIT = '63c1de2';
